// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_6tnTZygqLlNNj0Xh-R6hs","label":"_1Anxmp8eHgeJtGL_lnhZ5J","input":"_2d8wEq5zwr-aoWOzfHKtmc","border-error":"_3S-xJV6H08GXJQZPUHFurq","error":"OF4q0HiLy60t_2tYiGGjA"};